import React from "react";
import "./footer.scss";
import Layer from "./Layer.png";
import { translateString } from "../helpers/translator";

import LangEn from "../assets/images/lang-en.svg";
import LangRo from "../assets/images/lang-ro.svg";

export default function Footer({ language }) {
  const languageInsert = language === "en" ? "" : "/ro";

  return (
    <section className="footer">
      <div className="container">
        <div className="container__top">
          <div className="container__top__left">
            {translateString("FOOTER.copy", language)}
          </div>
          <div className="container__top__right">
            <div>
              <a
                href={languageInsert + "/blog"}
                style={{ color: "white", textDecoration: "none" }}
              >
                [BLOG]
              </a>

              <a
                href={
                  language == "ro"
                    ? window.location.pathname.includes(
                        "/aplicatii-hibride-vs-aplicatii-native"
                      )
                      ? "/article/hybrid-vs-native-apps"
                      : window.location.pathname.substr(3)
                    : window.location.pathname ===
                      "/article/hybrid-vs-native-apps"
                    ? "/ro/article/aplicatii-hibride-vs-aplicatii-native"
                    : "/ro" + window.location.pathname
                }
                style={{ color: "white", textDecoration: "none" }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;[
                {language == "ro" ? (
                  <>
                    Schimba in{" "}
                    <img
                      src={LangEn}
                      alt="engleza"
                      style={{ height: "21px" }}
                    />
                  </>
                ) : (
                  <>
                    Switch to <img src={LangRo} alt="romanian" />
                  </>
                )}
                ]
              </a>
            </div>
          </div>
        </div>

        <div className="container__image">
          <img src={Layer}></img>
        </div>

        <div className="footer__litigii">
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Soluționarea online a litigiilor (SOL)
          </a>
          |
          <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer">
            Protecția Consumatorului (ANPC)
          </a>
        </div>
      </div>
    </section>
  );
}
